export function frDate(iso, opts = {}) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        return d.toLocaleDateString("fr-FR", {
            day: "numeric",
            month: "long",
            year: "numeric",
            ...opts,
        });
    } catch {
        return iso;
    }
}

export function frShort(iso) {
    if (!iso) return "";
    try {
        return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });
    } catch {
        return iso;
    }
}

export function frTime(iso) {
    if (!iso) return "";
    try {
        return new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
    } catch {
        return "";
    }
}

export function humanSize(bytes) {
    if (!bytes) return "";
    const kb = bytes / 1024;
    if (kb < 1024) return `${Math.round(kb)} Ko`;
    return `${(kb / 1024).toFixed(1)} Mo`;
}
